import { useQuery } from "@tanstack/react-query";
import { authApi, authKeys } from "./api";

/**
 * Who the server thinks we are.
 *
 * Server state, so it lives in TanStack Query and nowhere else — copying it
 * into a Zustand store would create a second answer to "am I signed in?" that
 * can disagree with the first one after a session expires.
 */
export function useIdentity() {
  return useQuery({
    queryKey: authKeys.me,
    queryFn: authApi.me,
    // A 401 is the answer, not a transient failure. Retrying it just delays the
    // sign-in screen by three round trips.
    retry: false,
    // Unlike the registry (which only changes on deploy) a session expires on
    // its own, so this cannot be cached for the whole session.
    staleTime: 5 * 60 * 1000,
  });
}
